import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./pressure.css"; // ton style global unifié

import { Link } from "react-router-dom";
export default function InstallationsElectriquesView() {
  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    pauseOnHover: false,
  };

  return (
    <>
      <Header />
      <main className="prs">
        {/* === HERO avec slider === */}
        <section className="prs-hero">
          <div className="prs-hero__text">
            <h1>Installations électriques</h1>
            <p>
              La sécurité électrique constitue un pilier essentiel de la
              fiabilité industrielle. VERATRAC SAFETY accompagne ses clients
              pour garantir des installations sûres, performantes et conformes
              aux normes marocaines et internationales.
            </p>

            <div className="prs-hero__bullets">
              <span>⚡ Prévention des risques électriques</span>
              <span>🔥 Réduction du risque incendie</span>
              <span>📈 Amélioration de la productivité</span>
            </div>

            <a href="#contact" className="btn-primary">
              Demander un devis
            </a>
          </div>

          <div className="prs-hero__slider">
            <Slider {...sliderSettings}>
              <div><img src="/images/electricite/4.png" alt="Inspection installation électrique" /></div>
              <div><img src="/images/electricite/1.jpeg" alt="Contrôle de tableau basse tension" /></div>
              <div><img src="/images/electricite/3.jpeg" alt="Vérification d’armoire électrique" /></div>
              <div><img src="/images/electricite/2.jpeg" alt="Essais de continuité et isolement" /></div>
               <div><img src="/images/electricite/5.jpeg" alt="Vérification d’armoire électrique" /></div>
              <div><img src="/images/electricite/6.jpeg" alt="Essais de continuité et isolement" /></div>
               <div><img src="/images/electricite/7.jpeg" alt="Vérification d’armoire électrique" /></div>
             
            </Slider>
          </div>
        </section>

        {/* === Section détaillée === */}
        <section className="prs-reglement prs-simple">
  <h2>Pourquoi réaliser le contrôle&nbsp;?</h2>
  <p>
    Le contrôle des installations électriques vise à assurer la protection des personnes et des biens
    contre les risques d’électrocution, de court-circuit et d’incendie. Il garantit la conformité des
    équipements aux normes en vigueur et prévient les interruptions d’activité.
  </p>

  <ul>
    <li>Protection des travailleurs (contacts directs et indirects).</li>
    <li>Prévention des incendies (surcharges, isolement dégradé, mauvais raccordements).</li>
    <li>Fiabilité et disponibilité accrues des équipements.</li>
    <li>Facilitation des exigences des assureurs incendie.</li>
  </ul>

  <h3>Textes réglementaires applicables</h3>
  <ul>
    <li>Décret n° 2.22.630 du 17 novembre 2022</li>
    <li>Arrêté n°2538.23 du 11 octobre 2023</li>
    <li>NM 061-100 à 106 (référentiel basse tension inspiré de la NFC 15-100).</li>
    <li>UTE C13-100 et C13-200 (postes abonnés et HT).</li>
    <li>Code du travail et recommandations FMSAR.</li>
  </ul>

  <h3>Autorités compétentes</h3>
  <p>le Ministre de l’Insertion Economique, de la Petite Entreprise, de l’Emploi et des Compétences,
et la Ministre de la Transition Energétique et du Développement Durable.</p>

  <h3>Installations concernées</h3>
  <p>
    Toute entité industrielle, tertiaire ou administrative exploitant du courant électrique
    (bâtiments, ateliers, hôpitaux, ERP, entrepôts, stations-service, etc.).
  </p>

  <h3>Obligations réglementaires</h3>
  <ul>
    <li>Visite de réception avant mise en service.</li>
    <li>Visites périodiques : annuelle (ou semestrielle pour GPL/hydrocarbures).</li>
  </ul>

  <h3>Prestations complémentaires</h3>
  <ul>
    <li>Validation de plans/études, suivi de chantier, assistance à réception.</li>
    <li>Expertises indépendantes — sinistres et non-conformités.</li>
    <li>Thermographie IR et formation à l’habilitation électrique.</li>
  </ul>
  <div className="prs-btns">
            <Link to="/#contact" className="btn-primary">faire une consultation</Link>
          </div>
</section>

      </main>
      <Footer />
    </>
  );
}
